import React from 'react';
import { Segment, Button, Placeholder, Grid } from 'semantic-ui-react';
export default function ApplicationListItemPlaceholder() {
  return (
    <Placeholder fluid>
      <Segment.Group>
        <Segment>
          <Grid>
            <Grid.Column width={4}>
              <Placeholder style={{ maxWidth: '150px' }}>
                <Placeholder.Image square />
              </Placeholder>
            </Grid.Column>
            <Grid.Column width={12}>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
                <Placeholder.Line />
                <Placeholder.Line />
              </Placeholder>
            </Grid.Column>
          </Grid>
        </Segment>
        <Segment clearing>
          <Button disabled color='blue' floated='right' content='View' />
        </Segment>
      </Segment.Group>
    </Placeholder>
  );
}
